import React, { Component } from 'react';
import './ContactForm.scss';

export default class ContactForm extends Component {
  render() {
    const {
      formName = 'contact-form',
    } = this.props;
    return (
      <form
        className="contact-form"
        name={formName}
        method="post"
        action="/thank-you/"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <div className="col col-left">
          <input type="hidden" name="form-name" value={formName} />
          <label htmlFor="bot-field" style={{ display: 'none' }}>
            <span>Don’t fill this out:</span>
            <input name="bot-field" type="text" placeholder="Don’t fill this out!" />
          </label>
          <label className="field full-width" htmlFor="message">
            <span>Your message</span>
            <textarea id="message" name="message" placeholder="Tell us about your special occassion" rows="4" />
          </label>
          <label className="field half-width half-width-left" htmlFor="name">
            <span>Your name</span>
            <input type="text" id="name" name="name" placeholder="Aimee Song" required />
          </label>
          <label className="field half-width half-width-right" htmlFor="partner-name">
            <span>Your partner's name</span>
            <input type="text" id="partner-name" name="partner-name" placeholder="Henry Lee" required />
          </label>
        </div>
        <div className="col col-right">
          <label className="field full-width" htmlFor="email">
            <span>Email address</span>
            <input type="email" id="email" name="email" placeholder="Your email" required />
          </label>
          <label className="field full-width" htmlFor="phone">
            <span>Phone number</span>
            <input
              type="tel"
              pattern="^\+?\d{0,13}"
              id="phone"
              name="phone"
              placeholder="+61412345678"
              required
            />
          </label>
          <label className="field full-width" htmlFor="date">
            <span>Date of Event</span>
            <input type="text" id="date" name="date" placeholder="21-08-2021" />
          </label>
          <label className="field full-width" htmlFor="venue">
            <span>Venue Location</span>
            <input id="venue" name="venue" placeholder="Montsalvat, Melbourne, Australia" />
          </label>
          <div data-netlify-recaptcha="true" />
          <div className="form-actions">
            <button className="send-button styled-button" type="submit" aria-label="Send">
              <span>Send</span>
            </button>
          </div>
        </div>
      </form>
    );
  }
}
